import MyDiscoveries from "./MyDiscoveries";

export default MyDiscoveries;
